import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import styled from 'styled-components';
const ItemList = styled.div `
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(12, 1fr);
  margin-bottom: 28px;

  @media ${from(Device.Tablet)} {
    gap: 30px;
    margin-bottom: 36px;
  }

  @media ${from(Device.Desktop)} {
    gap: 30px;
    margin-bottom: 42px;
  }
`;
const ItemListHeader = styled.h2 `
  grid-column: span 12;
  ${fonts.sourceSansPro.semiBold};
  font-size: 20px;
  line-height: 30px;
  text-align: center;

  @media ${from(Device.Tablet)} {
    font-size: 24px;
    line-height: 32px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 35px;
    line-height: 45px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 45px;
    line-height: 55px;
  }
`;
const Item = styled.div `
  grid-column: span 12;

  @media ${from(Device.Tablet)} {
    grid-column: span 6;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: span ${({ spanColumns }) => 12 / spanColumns};
  }
`;
const Message = styled.p `
  ${ParagraphStyles.RegularStyles}
  grid-column: span 12;
  text-align: center;
`;
const CtaWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 84px 0;
`;
export default {
    Item,
    ItemList,
    ItemListHeader,
    Message,
    CtaWrapper,
};
